import { createClient } from '@supabase/supabase-js';
import { config } from '../config/env';

const MOCK_DELAY = 500; // Simulate network delay in development

function createSupabaseClient() {
  if (!config.validate()) {
    if (import.meta.env.DEV) {
      return null;
    }
    throw new Error('Supabase configuration is invalid');
  }

  return createClient(
    config.supabaseUrl,
    config.supabaseAnonKey
  );
}

const supabase = createSupabaseClient();

export interface NewsletterSubscription {
  email: string;
  source?: string;
}

export async function subscribeToNewsletter(data: NewsletterSubscription) {
  try {
    if (!supabase) {
      // Simulate network delay in development
      await new Promise(resolve => setTimeout(resolve, MOCK_DELAY));
      return { success: true }; // Mock success in development
    }

    const { error } = await supabase
      .from('newsletter_subscriptions')
      .insert([
        {
          email: data.email,
          source: data.source || 'website',
          status: 'active'
        }
      ]);

    if (error) throw error;
    return { success: true };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to subscribe';
    console.error('Newsletter subscription error:', error);
    throw new Error(`${errorMessage}. Please try again later.`);
  }
}